"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVoucherForm = useVoucherForm;
var RequestClearShoppingCache = _interopRequireWildcard(require("@ori-events/request-clear-shopping-cache"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
function useVoucherForm() {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerId
  } = (0, _contexts.useCheckoutBasket)();
  const sessionId = (0, _shoppingContext.useSessionId)();
  const [error, setError] = (0, _react.useState)();
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isTooltipOpen, setIsTooltipOpen] = (0, _react.useState)(false);
  const apiClient = (0, _globalApiClientReact.useApiClient)();
  const staticApiClient = (0, _staticApiClientReact.useApiClient)();
  const logger = (0, _logger.useLogger)('useVoucherForm');
  const {
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const handleClose = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const resetError = (0, _react.useCallback)(() => {
    setError('');
  }, []);
  const addVoucherCode = (0, _react.useCallback)(async voucherCode => {
    try {
      await (0, _utils.addVoucher)(voucherCode);
      setIsOpen(true);
      setError('');
      setValue('voucherCode', '');
      return true;
    } catch (actionError) {
      if (actionError instanceof Error) {
        logger.error(actionError);
        setIsOpen(true);
      } else {
        setError(actionError.toString());
      }
      return false;
    }
  }, [logger, setValue]);
  const handleAddToBasket = async formValues => {
    const {
      referral,
      voucher
    } = (0, _utils.splitPromoCode)(formValues.voucherCode);
    if (customerId !== _auth.NOT_LOGGED_IN_USER_ID) {
      await addVoucherCode(voucher ?? formValues.voucherCode);
      return;
    }
    try {
      const referralResponse = await (0, _staticApiClientReact.getTenantApplicationsShareAndEarnPersonalCodeCustomer)(staticApiClient, tenant, referral);
      try {
        await (0, _globalApiClientReact.createShoppingSessionReferral)(apiClient, sessionId, {
          customerId: referralResponse.data.customerId,
          referralType: _globalApiClientReact.GlobalShoppingReferralDtoReferralType.Pbs
        });
        (0, _checkoutUtils.setReferralInfo)(tenant, referral);
        if (voucher) {
          await (0, _utils.addVoucher)(voucher);
        }
        setIsOpen(true);
        setError('');
        setValue('voucherCode', '');
        const clearCache = new CustomEvent(RequestClearShoppingCache.Name);
        window.dispatchEvent(clearCache);
        // setTimeout is set so the shopping context is requested after caches are cleared
        setTimeout(() => {
          const eventToTrigger = new CustomEvent(RequestShoppingContextEvent.Name);
          window.dispatchEvent(eventToTrigger);
        });
      } catch (postReferralError) {
        const apiError = postReferralError;
        if (apiError.response?.data.Message) {
          setError(apiError.response.data.Message);
        }
        if (postReferralError instanceof Error) {
          logger.error(postReferralError);
        } else if (postReferralError !== '') {
          setError(postReferralError.toString());
        }
      }
    } catch (referralError) {
      const isReferralVoucherAdded = await addVoucherCode(referral);
      if (isReferralVoucherAdded && voucher) {
        await addVoucherCode(voucher);
      }
    }
  };
  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };
  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };
  const handleClick = () => {
    setIsTooltipOpen(prevState => !prevState);
  };
  return {
    error,
    handleAddToBasket,
    handleClick,
    handleClose,
    handleMouseEnter,
    handleMouseLeave,
    isOpen,
    isTooltipOpen,
    resetError
  };
}